module.exports = __webpack_public_path__ + "b2f18db67681ee7bf40dc69b029d8a9d.svg";